<!-- <template>
  <span :title="title">{{title}}</span>
</template> -->
<script>
export default {
    name: 'MenuItem',
    functional: true,
    props: {
        icon: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        }
    },
    render(h, context) {
        let { icon, title } = context.props;
        const vnodes = [];

        if (title.indexOf('sidebar.') > -1) {
            title = context.parent._i18n.t(title);
        }

        if (icon) {
            vnodes.push(<svg-icon icon-class={icon}/>);
        }

        if (title) {
            vnodes.push(<span slot='title'>{(title)}</span>);
        }


        return vnodes;
    }
};
</script>
<style lang="scss">

.svg-icon {
    margin-right: 20px;
}
.el-icon-arrow-right {
    right: 5px;
}

.el-scrollbar__view {
    overflow: hidden;
}
// .el-menu-item:not(.submenu-title-noDropdown) .first-letter, .hideSidebar span:not(.first-letter) {
//     display: none;
// }
</style>
